import React, { FC, useState } from 'react'

import { Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { isEqual } from 'lodash'
import { useTranslation } from 'react-i18next'

import iconSettings from '../../assets/icons/iconSettings.svg'

const CustomLinkComponent: FC<{ onClick: () => void }> = ({ onClick }) => {
  const { t } = useTranslation()
  const { spacing, palette } = useTheme()

  const [isHovered, setIsHovered] = useState(false)

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      gap={spacing(0.5)}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{ cursor: 'pointer', opacity: isHovered ? 0.8 : 1 }}
      width={spacing(17)}
    >
      <img src={iconSettings} alt="settings" />
      <Typography
        fontSize={spacing(1.75)}
        lineHeight={1}
        fontWeight="bold"
        color={palette.text.secondary}
      >
        {t('customize', 'Customize')}
      </Typography>
    </Box>
  )
}

export const CustomLink = React.memo(CustomLinkComponent, isEqual)
